import { ValueGetterParams } from 'ag-grid-community';
import { SimulationPayComponentsData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/PayComponents/helpers/definitions';
import { PayComponentsDataGridContext } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/PayComponents/types';
import { PAY_COMPONENT } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import { ORG_CHART_HR_SOFTWARE_ID } from 'routes/HumanResourcesModule/business/definitions';

export const envelopePayComponentHypothesisValueGetter = (
    params: ValueGetterParams<SimulationPayComponentsData>,
) => {
    const {
        data,
        context: { envelopePayComponentHypotheses },
    } = params;
    const hypotheses: PayComponentsDataGridContext['envelopePayComponentHypotheses'] =
        envelopePayComponentHypotheses;
    if (!data) return undefined;
    const hypothesis = hypotheses.find(
        (hyp) =>
            hyp[ORG_CHART_HR_SOFTWARE_ID] === data[ORG_CHART_HR_SOFTWARE_ID] &&
            hyp[PAY_COMPONENT] === data[PAY_COMPONENT],
    );
    return hypothesis;
};
